import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const conversationsService = {
    get,
    close,
    open,
    getCounters,
    assign,
    getArchivedCount,
    exportCSV,
    editBulk,
    create,
};

function get(params, pageToken = null, pageSize = 15) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };
    const nextPageToken = pageToken ? `&pageToken=${pageToken}` : '';
    return fetch(`${BASE_URL}api/inbox/conversations?${nextPageToken}&pageSize=${pageSize}`, requestOptions).then(
        handleResponse,
    );
}

function create(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/new`, requestOptions).then(handleResponse);
}

function close(conversationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}:close`, requestOptions).then(handleResponse);
}

function open(conversationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}:open`, requestOptions).then(handleResponse);
}

function getCounters(params) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/counters`, requestOptions).then(handleResponse);
}

function getArchivedCount() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify({}),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/archived`, requestOptions).then(handleResponse);
}

function assign(conversationId, params) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(params),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/${conversationId}:assign`, requestOptions).then(handleResponse);
}

function exportCSV(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/actions/export`, requestOptions).then(handleResponse);
}

function editBulk(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(`${BASE_URL}api/inbox/conversations/actions/edit`, requestOptions).then(handleResponse);
}
